import { render, staticRenderFns } from "./CheckBoxTableCachePage.vue?vue&type=template&id=dc0864e6&"
import script from "./CheckBoxTableCachePage.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxTableCachePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports